import { Component, OnInit } from '@angular/core';
import { GraphClientService } from '../services/graph-client-service';
import { LoginUnawareComponent } from '../login-unaware-component';
import { DateHelperService } from '../services/date-helper';
import { DiagnosticsServiceFactory } from '../services/diagnostics-service-factory';

const MAX_NUMBER_OF_EVENTS = 6;

/**
 * Displays a list of events sourced from an Office 365 mailbox. A special O365 licensed user
 * should be provisioned and 'invited' to important events. This way the events would reflect
 * in the special user's calendar that this component displays.
 * The component assumes that events are created in EST time zone.
 */
@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent extends LoginUnawareComponent implements OnInit {
  public eventTable: any[][];

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    private graphClient: GraphClientService,
    private dateHelper: DateHelperService) {
    super(diagnosticsFactory.create('EventsComponent'));
    this.eventTable = [];
  }

  ngOnInit() {
    const header = {'Prefer': 'outlook.timezone="Eastern Standard Time"'};
    const currentDate = (new Date()).toISOString();
    this.graphClient.getDataWithParameters(
        this.constructor.name,
        header,
        [currentDate, MAX_NUMBER_OF_EVENTS]
    ).subscribe(
      data => {
        const dynamicData = data as any;
        const allEvents = dynamicData.value as any[];
        let row: any[] = [];

        this.eventTable = allEvents.reduce((table: any[][], item: any, i: number) => {
          if (i % 2 === 0) {
            row = [];
            table.push(row);
          }

          row.push({
            subject: item.subject,
            start: this.dateHelper.formatStartDateAndTime(item.start.dateTime),
            end: this.dateHelper.formatEndDateAndTime(item.start.dateTime, item.end.dateTime),
            location: (item.location) ? item.location.displayName : null
          });

          return table;
        }, []);
      }, error => {
        this.diagnostics.logError(`ERROR loading data. Details: ${ JSON.stringify(error) }`);
    });
  }
}
